export default {
  text: 'Du optjener <highlight>{{value}} point</highlight> med denne ordre',
};
